import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import CmsBlockTable from "@/helpers/editor/blocks/CmsBlockTable.js";
import CmsBaseClass from "@/helpers/cms/CmsBaseClass.js";

/**
 * This is not a block, but a data only class to configure columns in one table
 */
export default class CmsBlockTableColumn extends CmsBaseClass {
    generateId() {
        return false;
    }

    constructor(data) {
        super(data);

        if (!data) {
            this.name = null;
            this.span = 1;
        }
    }

    setIndex(index) {
        this.name = String.fromCharCode(index % 26 + 65);
        if (index > 26) {
            this.name += Math.floor(index / 26);
        }
    }
}
